export default __webpack_public_path__ + "static/media/LSSeng.6d2c855e.pdf";